/**
 * Transforms a single diagram item to the GraphQL node format
 */
export function mapDiagramToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
    };
}
/**
 * Transforms a paginated list of diagrams to the GraphQL format
 */
export function mapPaginatedDiagrams(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapDiagramToNode) ?? [],
    };
}
